import Vue from "vue";
import {
  COMPANYTYPE,
  REGISTERTYPE,
  DRIVERSEAT,
  HKVEHICLEREGISTERTYPE,
} from "./enums";
import i18n from "../public/lang/index";

// 金額
export function formatAmount(value) {
  if (!value) return "MOP 0.00";
  let num = Number(value);
  return "MOP " + num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
}

// 基礎數據取值
Vue.filter("vssTypesFilter", function (value, types) {
  if (!value) return "";
  const type = types.find((ele) => ele.codeKey === value);
  if (type) {
    return type[i18n.t("message.codeName")];
  } else {
    return value;
  }
});

export function companyType(value) {
  if (!value) return "";
  switch (value) {
    case COMPANYTYPE.CO:
      return i18n.t("message.companyTypeCO");
    case COMPANYTYPE.EM:
      return i18n.t("message.companyTypeEM");
    case COMPANYTYPE.SO:
      return i18n.t("message.companyTypeSO");
    default:
      return value;
  }
}

export function registerType(value) {
  if (!value) return "";
  switch (value) {
    case REGISTERTYPE.PERSON:
      return i18n.t("hzmbG.enum.registerType.PERSON");
    case REGISTERTYPE.COMPANY:
      return i18n.t("hzmbG.enum.registerType.COMPANY");
    default:
      return value;
  }
}

export function driverSeat(value) {
  if (!value) return "";
  switch (value) {
    case DRIVERSEAT.E:
      return i18n.t("hzmbG.enum.driverSeat.E");
    case DRIVERSEAT.D:
      return i18n.t("hzmbG.enum.driverSeat.D");
    default:
      break;
  }
}

export function hkVehicleRegisterType(value) {
  if (!value) return "";
  switch (value) {
    case HKVEHICLEREGISTERTYPE.LIGHT_TRUCK:
      return i18n.t("hzmbG.enum.hkVehicleRegisterType.LIGHT_TRUCK");
    case HKVEHICLEREGISTERTYPE.MEDIUM_TRUCK:
      return i18n.t("hzmbG.enum.hkVehicleRegisterType.MEDIUM_TRUCK");
    case HKVEHICLEREGISTERTYPE.HEAVY_TRUCK:
      return i18n.t("hzmbG.enum.hkVehicleRegisterType.HEAVY_TRUCK");
    case HKVEHICLEREGISTERTYPE.TRACTOR:
      return i18n.t("hzmbG.enum.hkVehicleRegisterType.TRACTOR");
    case HKVEHICLEREGISTERTYPE.TOW_TRUCK:
      return i18n.t("hzmbG.enum.hkVehicleRegisterType.TOW_TRUCK");
    default:
      break;
  }
}

/**
 * 首次/續期
 * @param {*} serviceType
 * @returns
 */
export const applicationTypeFilter = (serviceType) => {
  if (!serviceType) return "";
  let type = "";
  switch (serviceType) {
    case "HZMB_FIRST_PERSON":
    case "HZMB_FIRST_COMPANY":
    case "HZMB_CHANGE_COMP":
    case "HZMB_GH_CHANGE_COMP":
      type = "FIRST";
      break;
    case "HZMB_RENEW_PERSON":
    case "HZMB_RENEW_COMPANY":
    case "HZMB_MO_RENEW_PERSON":
    case "HZMB_MO_RENEW_COM":
      type = "RENEW";
      break;
    default:
      break;
  }
  return type;
};
/**
 * 個人/公司
 * @param {*} serviceType
 * @returns
 */
export const applicantTypeFilter = (serviceType) => {
  if (!serviceType) return "";
  let type = "";
  switch (serviceType) {
    case "HZMB_FIRST_PERSON":
    case "HZMB_RENEW_PERSON":
    case "HZMB_MO_RENEW_PERSON":
    case "HZMB_CHANGE_PERSON":
      type = "PERSON";
      break;
    case "HZMB_FIRST_COMPANY":
    case "HZMB_RENEW_COMPANY":
    case "HZMB_MO_RENEW_COM":
    case "HZMB_CHANGE_COMP":
    case "HZMB_GH_CHANGE_COMP":
      type = "COMPANY";
      break;
    default:
      break;
  }
  return type;
};

// 驗證文件格式
export const fileExt = function (name, ext) {
  var FileExt = name.replace(/.+\./, "");
  var flag = false;
  if (ext.toLowerCase().indexOf(FileExt.toLowerCase()) !== -1) {
    flag = true;
  }
  return flag;
};

// 驗證文件大小
export const fsLimit = function (size, max) {
  return size / 1024 / 1024 < max;
};

export const wordBreak = function (value) {
  if (!value) return "";
  if (value.indexOf("\\n") != -1) {
    // let reg = new RegExp("\\n",)
    return value.replace(/\\n/g, "\n");
  } else {
    return value;
  }
};
